'use client';

import type {
  Content,
  GroupField,
  KeyTextField,
  LinkField,
  RichTextField,
} from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import type { Simplify } from '../../../../../prismicio-types';
import { Button } from '@/components';
import { useVisible } from '@/hooks';
import { consistentAnimationDuration } from '@/utils';
import { ProspectData } from '@/types/salesforce';
import NextButton from '@/components/Button/NextButton';
import { MODAL_NAMES } from '@/constants/modals';
import useModal from '@/hooks/useModal';
import styles from './personalLoansCards.module.scss';

interface PersonalLoansCardsProps {
  cards: GroupField<
    Simplify<Content.PersonalLoansSliceDefaultPrimaryAboutItemsItem>
  >;
  heading: RichTextField;
  buttonText: KeyTextField;
  link: LinkField;
  prospect?: ProspectData;
  variant: 'default' | 'engineLanding';
}

export const PersonalLoansCards = ({
  buttonText,
  heading,
  link,
  cards,
  variant,
  prospect,
}: PersonalLoansCardsProps) => {
  const [isVisible, id] = useVisible();
  const { openModal } = useModal();

  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <article className={styles.cards} id={id}>
      <ul className={styles.list}>
        {cards.map((item, index) => (
          <li
            key={item.description}
            className={`${styles.card} ${isVisibleStyles} `}
            style={consistentAnimationDuration(1.1, index)}
          >
            <span className={styles.heading}>{item.heading}</span>
            <p className={styles.value}>{item.value}</p>
            <p className={styles.description}>{item.description}</p>
          </li>
        ))}
      </ul>
      <div className={`${styles.about} ${isVisibleStyles}`}>
        <div className={styles.about_heding}>
          {variant === 'engineLanding' ? (
            'Schedule a call with your loan advisor'
          ) : (
            <PrismicRichText field={heading} />
          )}
        </div>
        {variant === 'engineLanding' ? (
          <NextButton
            type="button"
            buttonType="button"
            styles={styles.button}
            text="Click to finalize and review your offer"
            isArrow
            variation="white"
            onClick={() =>
              openModal({
                name: MODAL_NAMES.engine,
                data: { prospect: prospect || null },
              })
            }
          />
        ) : (
          <Button
            link={link}
            text={buttonText}
            variation="white"
            styles={styles.button}
          />
        )}
      </div>
    </article>
  );
};
